import React, { useEffect, useState } from "react";
import ProductoList from "./ProductoList";
import CarritoPrestamo from "./CarritoPrestamo";
import {
  getClienteHabilitado,
  cargarUsuarioActual,
} from "../redux/actions/index";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import ProductoListPrestamos from "./ProductoListPrestamos";

const Prestamos = () => {
  const [carrito, setCarrito] = useState([]); // Estado del carrito
  const [dni, setDni] = useState("");
  const usuarioId = useSelector((state) => state.usuario.id);

  const dispatch = useDispatch();
  const [clienteId, setClienteId] = useState("");
  const [habilitado, setHabilitado] = useState(false);

  useEffect(() => {
    dispatch(cargarUsuarioActual());
  }, [dispatch]);

  const agregarAlCarrito = (producto) => {
    const productoExistente = carrito.find((p) => p.id === producto.id);

    if (productoExistente) {
      setCarrito(
        carrito.map((p) =>
          p.id === producto.id
            ? {
                ...p,
                cantidad: Math.min(
                  p.cantidad + producto.cantidad,
                  producto.stock
                ),
              }
            : p
        )
      );
    } else {
      setCarrito([...carrito, producto]);
    }
  };

  // Función para actualizar el carrito desde el componente Carrito
  const actualizarCarrito = (nuevoCarrito) => {
    setCarrito(nuevoCarrito);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const isHabilitado = await dispatch(getClienteHabilitado(dni));

      if (isHabilitado.habilitado === true) {
        setHabilitado(true);
        setClienteId(isHabilitado.clienteId);
      } else {
        Swal.fire({
          title: "Cliente Inhabilitado",
          text: `El cliente con DNI ${dni} no está habilitado.`,
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      }
    } catch (error) {
      console.error("Error durante la validación:", error);
      Swal.fire({
        title: "Error",
        text: "Ocurrió un problema al validar el cliente. Inténtalo nuevamente.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  };

  return (
    <div>
      <div
        className={
          habilitado
            ? "hidden"
            : "h-screen bg-backgroundOscuro flex flex-col items-center justify-center px-8 py-12 md:px-16 md:py-24"
        }
      >
        <div className="space-y-6">
        <form
            onSubmit={handleSubmit}
            className={habilitado ? "hidden" : "space-y-4"}
          >
            <div className="space-y-2">
              <label htmlFor="dni" className="text-textoClaro font-bold text-lg block">
                DNI del cliente
              </label>
              <input
                id="dni"
                className="bg-backgroundClaro border-[#404040] text-textoOscuro focus:ring-4 focus:ring-gray-500 focus:border-gray-500 w-full p-2 sm:p-1"
                value={dni}
                placeholder="dni cliente que va a retirar"
                onChange={(e) => setDni(e.target.value)}
                required
              />
            </div>
            <div className="grid gap-4">
              <button
                type="submit"
                className="bg-green-900 p-2 rounded-md text-textoClaro font-bold text-lg hover:bg-green-600 shadow-lg shadow-green-500/50"
              >
                Validar
              </button>
            </div>
          </form>
        </div>
      </div>

      {habilitado ? (
        <div className="grid p-4 grid-cols-1 h-full gap-4 md:grid-cols-2 md:gap-8 bg-backgroundClaro">
        <>
          <div className="rounded-lg h-full bg-backgroundOscuro">
            <ProductoListPrestamos
              carrito={carrito}
              agregarAlCarrito={agregarAlCarrito}
            />
          </div>
          <div className="min-h-screen h-auto bg-backgroundOscuro rounded-lg p-4">
            <CarritoPrestamo
              carrito={carrito}
              setCarrito={actualizarCarrito}
              clienteId={clienteId}
              usuarioId={usuarioId}
              tipo="prestamo"
            />
          </div>
        </>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Prestamos;
